import { Dispatch } from 'redux'
import {
	EMISSIONTYPES_ERROR,
	EMISSIONTYPES_LOADED,
	EMISSIONTYPES_LOADING,
} from '../slices/emissionTypesSlice'
import { NeoniApi, RequestOptions } from '../../lib/api'
import { getApiErrorMessage } from '../../lib/utils'

export const getScope1EmissionTypes = (api: NeoniApi, year?: string, options?: RequestOptions) => async (dispatch: Dispatch) => {
	dispatch({
		type: EMISSIONTYPES_LOADING,
	})
	try {
		const body = await api.get(`scope_1_emission_types/`, options)
		if (options?.signal?.aborted) return

		if (body.success === true) {
			// Successfully fetched emission types
			dispatch({
				type: EMISSIONTYPES_LOADED,
				payload: {
					scope1: body.emissionFactors,
				},
			})
		} else {
			// Error
			dispatch({
				type: EMISSIONTYPES_ERROR,
				payload: getApiErrorMessage({ body }, 'Could not load emission types. Please try again.'),
			})
		}
	} catch (error) {
		if (options?.signal?.aborted) return
		dispatch({
			type: EMISSIONTYPES_ERROR,
			payload: getApiErrorMessage(error, 'Could not load emission types. Please try again.'),
		})
	}
}
